<template>
  <SummaryCard
    :title="$t('views.portfolio.topPortfolioValue.title')"
    :infoText="$t('views.portfolio.topPortfolioValue.info')"
    :loading="loadingSummary"
    :value="totalValueBaseCurrency"
    :valueCurrency="user.baseCurrency"
    :subtitle="
      totalCostWithComissionBaseCurrency
        ? `${$t('views.portfolio.topPortfolioValue.subtitle')}: ${
            !hideAmounts ? totalCostWithComissionBaseCurrency : ''
          }`
        : ''
    "
  />
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import { getCurrencyValueAsString } from '@/lib/utils/currencies.js'
import SummaryCard from '@/views/components/dashboardDetail/summary/SummaryCard'

export default {
  components: { SummaryCard },
  props: {
    summary: {
      type: Object,
      default: () => {},
    },
    loadingSummary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState(['user', 'hideAmounts']),
    totalValueBaseCurrency() {
      return get(this.summary, 'totalValueBaseCurrency', null)
    },
    totalCostWithComissionBaseCurrency() {
      const value = get(this.summary, 'totalCostWithComissionBaseCurrency', null)
      return getCurrencyValueAsString({
        value,
        currency: this.user.baseCurrency,
      })
    },
  },
}
</script>
